module.exports = __webpack_public_path__ + "static/foodmyway-8868c8efb4cd994a8b8d2e499d026058.jpg";